<template>
  <div class="container" style="margin-top: 3cm">
    <h2 class="text-center">2025年度四川省企业管理现代化创新成果与优秀论著文入围名单公示</h2>
    <p class="box_p text-center">
      <span>发布时间： </span>
      <span id="date" style="display: inline-block; margin-left: -10px">
         2025-11-14 15:36:33
        </span>
      <span style="margin-left: 16px">编辑： </span>
      <span id="author" style="display: inline-block; margin-left: -10px">
         管理员
        </span>
    </p>
    <div style="letter-spacing:2px">
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2025年度四川省企业管理现代化创新成果与论著文专家评议阶段已结束。现公布本年度入围成果与论著文名单。本次公布仅为入围名单，最终结果将在11月27日举行的管理创新大会上发布。
      请入围企业和创作人员仔细核对企业（单位）、主创人、参与创作人名称/名字，如有任何问题请在11月20日之前联系四川企联企业创新工作部。<br>
      联系电话：028-85182812
      <dl>
        <dt>附件下载：</dt>
        <dd><a style="color: #1c84c6" href="static/file/2025年度四川省企业管理现代化创新成果入围名单.pdf" download>2025年度四川省企业管理现代化创新成果入围名单</a></dd>
        <dd><a style="color: #1c84c6" href="static/file/2025年度四川省企业管理现代化优秀论著文入围名单.pdf" download>2025年度四川省企业管理现代化优秀论著文入围名单</a></dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/NoticeDetails.vue